import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';
import { useAuth } from '@/context/AuthContext';

type PlanFeatureName =
  | 'audit'
  | 'kanban'
  | 'gantt'
  | 'bridges'
  | 'okrs'
  | 'programs'
  | 'portfolios'
  | 'committees'
  | 'dashboard_executive'
  | 'executive_reports'
  | 'email_notifications'
  | 'audit_trail'
  | 'api_keys'
  | 'monitoring'
  | 'cost_management';

interface FeatureGuardProps {
  feature: PlanFeatureName;
  children: React.ReactNode;
}

const PLAN_NAMES: Record<string, string> = {
  free: 'Gratuito',
  basic: 'Básico',
  pro: 'Profissional',
  premium: 'Premium',
};

const FeatureGuard: React.FC<FeatureGuardProps> = ({ feature, children }) => {
  const navigate = useNavigate();
  const { auditEnabled, hasFeature, plan } = useAuth();

  const isFeatureEnabled = () => {
    // Legacy audit toggle check
    if (feature === 'audit') {
      return auditEnabled;
    }
    // Plan-based feature check
    return hasFeature(feature);
  };

  if (!isFeatureEnabled()) {
    const currentPlan = plan ?? 'free';
    const planName = PLAN_NAMES[currentPlan] || currentPlan;
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '24px' }}>
        <Result
          status="warning"
          icon={<LockOutlined style={{ color: '#faad14' }} />}
          title="Funcionalidade Indisponível"
          subTitle={`Este recurso não está disponível no plano ${planName}. Entre em contato com o administrador para fazer upgrade.`}
          extra={[
            <Button type="primary" key="home" onClick={() => navigate('/')}>
              Voltar para Home
            </Button>,
            <Button key="plans" onClick={() => navigate('/admin/planos')}>
              Ver Planos
            </Button>,
          ]}
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default FeatureGuard;
